export function hasDomainName(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return !!parsedUrl.hostname;
  } catch (e) {
    return false;
  }
}
